import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { VerifyMfaRequest, VerifyMfaResponse } from '../../../../shared/types/routes/auth/mfa';

/**
 * Verifies an MFA code (TOTP, email, or backup) during login via `POST /api/auth/mfa/login/verify`,
 * completing the partially-authenticated session on success. No toast is wired here — the challenge step
 * renders a wrong-code failure inline and reserves toasts for unexpected errors, mirroring useCredentialLogin.
 */
export function useVerifyMfa() {
  return useToastedMutation({
    mutationFn: async (body: VerifyMfaRequest) =>
      (await post<VerifyMfaRequest, VerifyMfaResponse>('/api/auth/mfa/login/verify', body)).data,
  });
}
